/**
 * Records a live call's turns as they are transcribed and archives the whole thing when the call ends
 * (internal wiki page + Brand OS insights on the backend). Fire-and-forget; never blocks the UI.
 */
import { coworkApi } from '@/cowork/omniad/api/coworkApi';

export class CallRecorder {
  private turns: Array<{ role: 'agent' | 'user' | 'room'; text: string; at: string }> = [];
  private startedAt = new Date().toISOString();
  private archived = false;
  private meta: { kind: 'presentation' | 'kickoff' | 'proposal' | 'meeting'; agent: string; title: string; brandId?: string; refId?: string | null; userName?: string | null; context?: string };
  constructor(meta: { kind: 'presentation' | 'kickoff' | 'proposal' | 'meeting'; agent: string; title: string; brandId?: string; refId?: string | null; userName?: string | null; context?: string }) { this.meta = meta; }
  /** Call with FINAL transcripts only. */
  add(role: 'agent' | 'user' | 'room', text: string) { const t = (text || '').trim(); if (t) this.turns.push({ role, text: t, at: new Date().toISOString() }); }
  get count() { return this.turns.length; }
  async archive(): Promise<void> {
    if (this.archived || this.turns.length < 2) return;
    this.archived = true;
    try { await coworkApi.calls.archive({ ...this.meta, startedAt: this.startedAt, endedAt: new Date().toISOString(), turns: this.turns }); }
    catch (e) { console.warn('[call-archive] failed:', (e as Error).message); }
  }
}
